import React from "react";

const Input = ({
  id,
  type,
  value,
  onChange,
  className,
  placeholder,
  disabled,
  accept,
  maxLength,
}) => {
  return (
    <>
      <input
        id={id}
        type={type}
        value={value}
        maxLength={maxLength}
        onChange={onChange}
        className={className}
        placeholder={placeholder}
        disabled={disabled}
        accept={accept}
      />
    </>
  );
};

export default Input;
